import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import "../js/turbo_hack.js";
import "channels";
ActiveStorage.start();
import "@fortawesome/fontawesome-free/css/all";
require("trix");
require("@rails/actiontext");
import "controllers";
import 'bootstrap';

document.addEventListener("turbo:before-visit", function (event) {
  const url = event.detail.url;
  const currentHost = window.location.host;
  const isExternalUrl = !url.includes(currentHost) && (url.startsWith('http://') || url.startsWith('https://'));

  if (isExternalUrl) {
    cleanupSubscriptions();
    return;
  }

  const isGoingToResultsPage = url.match(/\/(decode|vin_compare|match)\/[^\/]+(\/[^\/]+)?$/) ||
    url.match(/\/searches\/\d+/);

  const currentlyHasStreams = document.querySelectorAll("turbo-cable-stream-source").length > 0;

  if (currentlyHasStreams && !isGoingToResultsPage) {
    cleanupSubscriptions();
  }

});

function cleanupSubscriptions() {
  const streamSources = document.querySelectorAll("turbo-cable-stream-source");
  streamSources.forEach(source => {
    if (source.subscription) {
      source.subscription.unsubscribe();
      source.subscription = null;
    }
  });
}
